// extracted by mini-css-extract-plugin
export default {"selectedGroup":"assignReviewForm_selectedGroup__cXa3M","groupName":"assignReviewForm_groupName__g2TYn"};